import AdminLayoutSideBarItem from "./AdminLayoutSideBarItem";
import {
  Category,
  Book,
  Teacher,
  MessageQuestion,
  Logout,
  DocumentText1,
  ShieldTick,
  Cup,
  PlayCircle,
  Image,
} from "iconsax-reactjs";

export interface SidebarItem {
  id: string;
  label: string;
  icon?: React.ReactNode;
  path?: string;
  notifition?: string;
  children?: SidebarItem[];
}

export const sidebarData: SidebarItem[] = [
  {
    id: "dashboard",
    label: "داشبورد",
    icon: <Category variant="Outline" size={24} />,
    path: "/",
    notifition: "",
    children: [],
  },
  {
    id: "sepehr-jo",
    label: "مدیریت سوال و جواب",
    icon: <MessageQuestion variant="Outline" size={24} />,
    path: "",
    notifition: "",
    children: [
      {
        id: "questions-list",
        label: "لیست سوالات",
        path: "/sepehr-jo/questions",
        notifition: "",
      },
      {
        id: "answers-list",
        label: "لیست پاسخ‌ها",
        path: "/sepehr-jo/answers",
        notifition: "",
      },
    ],
  },
  {
    id: "sepehr-jo-authorization",
    label: "احراز هویت",
    icon: <ShieldTick variant="Outline" size={24} />,
    path: "",
    notifition: "",
    children: [
      {
        id: "authorization-student",
        label: "احراز هویت دانش‌آموز",
        path: "/sepehr-jo/authorization/student",
        notifition: "",
      },
      {
        id: "authorization-teacher",
        label: "احراز هویت معلم",
        path: "/sepehr-jo/authorization/teacher",
        notifition: "",
      },
    ],
  },
  {
    id: "post",
    label: "مدیریت پست‌ها",
    icon: <DocumentText1 variant="Outline" size={24} />,
    path: "/post",
    notifition: "",
    children: [],
  },
  {
    id: "article",
    label: "مدیریت مقالات",
    icon: <Book variant="Outline" size={24} />,
    path: "/article",
    notifition: "",
    children: [],
  },
  {
    id: "event",
    label: "مدیریت رویدادها",
    icon: <Teacher variant="Outline" size={24} />,
    path: "/event",
    notifition: "",
    children: [],
  },
  {
    id: "course",
    label: "مدیریت دوره‌ها",
    icon: <PlayCircle variant="Outline" size={24} />,
    path: "/course",
    notifition: "",
    children: [],
  },
  {
    id: "challenge",
    label: "مدیریت چالش‌ها",
    icon: <Cup variant="Outline" size={24} />,
    path: "/challenge",
    notifition: "",
    children: [],
  },
  {
    id: "banners",
    label: "بنر ها",
    icon: <Image variant="Outline" size={24} />,
    path: "/banners",
    notifition: "",
    children: [],
  },
  // {
  //   id: "courses",
  //   label: "مدیریت دوره‌ها",
  //   icon: <Notepad variant="Outline" size={24} />,
  //   path: "/course",
  //   notifition: "inprogress-courses pending-courses",
  //   children: [],
  // },
  // {
  //   id: "payout",
  //   label: "مدیریت مالی",
  //   icon: <EmptyWallet variant="Outline" size={24} />,
  //   path: "/payout",
  //   notifition: "payouts",
  //   children: [],
  // },
  // {
  //   id: "skyroom",
  //   label: "اسکای روم",
  //   icon: <Video variant="Outline" size={24} />,
  //   path: "/skyroom",
  //   notifition: "",
  //   children: [],
  // },
  // {
  //   id: "user",
  //   label: "لیست کاربران",
  //   icon: <UserSearch variant="Outline" size={24} />,
  //   path: "/user",
  //   notifition: "",
  //   children: [],
  // },
  // {
  //   id: "tickets",
  //   label: "پشتیبانی",
  //   icon: <InfoCircle variant="Outline" size={24} />,
  //   path: "/ticket",
  //   notifition: "pending-tickets",
  //   children: [],
  // },
  // {
  //   id: "report",
  //   label: "گزارشات",
  //   icon: <MessageQuestion variant="Outline" size={24} />,
  //   path: "/report",
  //   notifition: "",
  //   children: [],
  // },
  // {
  //   id: "message",
  //   label: "ارسال پیام",
  //   icon: <Message variant="Outline" size={24} />,
  //   path: "/message",
  //   notifition: "",
  //   children: [],
  // },
  {
    id: "logout",
    label: "خروج از حساب",
    icon: <Logout variant="Outline" size={24} />,
    path: "",
    notifition: "",
    children: [],
  },
];

interface AdminLayoutSideBarProps {
  items: SidebarItem[];
  enabledItemIds: Set<string>;
  isRestrictedRole?: boolean;
}

export default function AdminLayoutSideBar({
  items,
  enabledItemIds,
  isRestrictedRole = false,
}: AdminLayoutSideBarProps) {
  const notifications = [""];

  return (
    <aside>
      {items.map((item) => (
        <AdminLayoutSideBarItem
          key={item.id}
          item={item}
          notifications={notifications}
          enabledItemIds={enabledItemIds}
          isRestrictedRole={isRestrictedRole}
        />
      ))}
    </aside>
  );
}
